import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@material-ui/core'
import { ErrorConfig } from 'graphql/types'
import { useTranslation } from 'react-i18next'
import colors from 'theme/colors'
export interface ErrorDialogProps {
    errorConfig?: ErrorConfig
    onClose: () => void
}

const ErrorDialog = (props: ErrorDialogProps): JSX.Element => {
    const { errorConfig, onClose } = props
    const { t } = useTranslation()

    return (
        <div>
            {errorConfig && (
                <Dialog
                    disableBackdropClick={false}
                    disableEscapeKeyDown={false}
                    aria-labelledby={'customized-dialog-title'}
                    open={true}
                >
                    {/* <DialogTitle id={'customized-dialog-title'}>{errorConfig.title}</DialogTitle>
                    <DialogContent style={{ padding: '24px' }} dividers>
                        <Typography>{errorConfig.content}</Typography>
                        {errorConfig.messages && <Typography>{errorConfig.messages}</Typography>}
                    </DialogContent> */}
                    <DialogTitle id={'customized-dialog-title'}>{t('graphQLErrorTitle')}</DialogTitle>
                    <DialogContent style={{ padding: '24px' }} dividers>
                        <Typography>{t('graphQLErrorContent')}</Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button style={{ backgroundColor: colors.green }} onClick={onClose}>
                            {t('ok')}
                        </Button>
                    </DialogActions>
                </Dialog>
            )}
        </div>
    )
}

export default ErrorDialog
